export default function now() {
    if (typeof window === 'undefined' || !('performance' in window)) {
        return Date.now();
    }
    return performance.now();
}
//# sourceMappingURL=now.js.map